<template lang="pug">
  .agency-list
    h2.primary--text {{ isSelection ? 'Agentur wählen' : 'Agenturen' }}

    v-row.align-center.mt-4
      v-col(cols="6")
        v-text-field.pt-0(
          v-model="search"
          append-icon="search"
          placeholder="Suchen"
          outlined
          single-line
          hide-details
        )

      v-col.text-right(v-if='!isSelection' cols="6")
        v-btn(color="primary" @click="gotoRoute('agency-add')") + Neue Agentur

    v-data-table.mt-4(
      v-bind="tableProps"
      :headers="headers"
      :items="agencies"
      :search="search"
      :options="defaultPagination"
    )
      tr(
        slot="item"
        slot-scope="{ item }"
        :style="{ 'background-color': (!item.is_active ? '#FCE4EC' : 'white') }"
      )
        td.text-left {{ item.id }}
        td.text-left {{ item.name }}
        td.text-center: i.fo.fo-large.fo-check(v-if="item.is_active")
        td.text-center: i.fo.fo-large.fo-check(v-if="item.ignore_for_ewe")
        td.text-right(v-if="!isSelection")
          a.mr-1(title="Agentur bearbeiten" @click.prevent="onEditAgency(item)")
            i.fo.fo-large.fo-pencil

          a(
            v-if="!selectedAgency || selectedAgency.id !== item.id"
            title="Agentur löschen"
            @click.prevent="onDeleteAgency(item)"
          )
            i.fo.fo-trash-bin

        td.text-right(v-else)
          a.mr-1(
            v-if="!selectedAgency || selectedAgency.id !== item.id"
            title="Agentur wählen"
            @click.prevent="onSelectAgency(item)"
          )
            svg-star(color="primary" size=18)

      template(#footer.page-text="{ pageStart, pageStop }")
        span Von {{ pageStart }} bis {{ pageStop }}

</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'

import FormMixin from '@/mixins/form'
import Urls from '@/router/urls'

@Component({
  mixins: [
    FormMixin
  ],

  components: {
    SvgStar: () => import('@/components/svgs/svg-star')
  }
})
export default class AgencyList extends Vue {
  @Prop({ type: Boolean, default: false }) isSelection

  search = ''

  headers = [
    {
      text: 'AV-Nr',
      align: 'left',
      sortable: true,
      value: 'id'
    },
    {
      text: 'Name',
      align: 'left',
      sortable: false,
      value: 'name'
    },
    {
      text: 'Aktiv',
      align: 'center',
      sortable: true,
      value: 'is_active'
    },
    {
      text: 'Keine EWE',
      align: 'center',
      sortable: true,
      value: 'ignore_for_ewe'
    },
    {
      text: 'Aktion',
      align: 'right',
      sortable: false,
      value: '#'
    },
  ]

  onEditAgency (item) {
    this.$router.push({
      name: 'agency-edit',
      params: {
        id: item.id
      }
    })
  }

  onDeleteAgency (item) {
    const handleDeleteAgency = () => {
      this.$axios
        .delete(Urls.Agency(item.id))
        .then(() => {
          this.loadAgencies()
          this.$confirmDialog.close()
        })
    }

    this.$confirmDialog.show({
      text: 'Wollen Sie die Agentur wirklich löschen?',
      handleOk: handleDeleteAgency
    })
  }

  onSelectAgency (item) {
    this.selectAgency(item)
      .then(() => {
        this.loadCompanies()
        this.selectCompany(null)
        this.gotoRoute('company-list')
      })
  }
}
</script>
